var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHantLogo = function SvgHantLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 100 31"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD960",
    fillRule: "evenodd",
    d: "m3.193 9.692 12.313-7.586v15.173L3.192 9.692Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00AFE6",
    fillRule: "evenodd",
    d: "m3.193 22.634 12.313-7.586V30.22L3.192 22.634Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF71AC",
    fillRule: "evenodd",
    d: "M0 16.163 18.7 4.64v23.044L0 16.163Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.629 2.094h6.229v8.987c1.125-1.904 3.226-2.665 5.44-2.665 3.19 0 5.066 1.142 6.193 3.008 1.125 1.828 1.425 4.342 1.425 7.046v11.806h-6.228v-11.5c0-1.181-.15-2.286-.638-3.085-.525-.8-1.352-1.334-2.702-1.334-1.726 0-2.627.8-3.04 1.714-.45.914-.45 1.942-.45 2.475v11.73H21.63V2.094h-.001Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M47.377 0h5.966v5.75h-5.966z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M56.119 0h5.966v5.75h-5.966z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M67.156 9.14h5.817v2.247c.713-1.029 2.026-2.97 5.741-2.97 7.017 0 7.73 5.789 7.73 8.645v13.215h-6.228v-11.54c0-2.322-.487-4.38-3.264-4.38-3.078 0-3.565 2.248-3.565 4.418v11.502H67.16V9.14h-.003Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M90.769 13.94H87.69v-4.8h3.078V2.094h6.228V9.14H100v4.798h-3.002v16.338H90.77V13.94Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M58.987 11.387V9.14h6.228v21.137h-6.228v-2.285C57.86 30.048 55.27 31 52.832 31c-6.604 0-10.469-5.256-10.469-11.31 0-6.931 4.915-11.273 10.47-11.273 3.414 0 5.328 1.675 6.154 2.97Zm-.863 11.349c.525-.838.787-1.752.863-2.704a5.488 5.488 0 0 0-.527-2.781c-.674-1.447-2.1-2.932-4.727-2.932-3.565 0-5.141 3.047-5.141 5.446v.038c0 1.943 1.425 5.294 5.178 5.294 2.215 0 3.566-1.066 4.354-2.361Z",
    clipRule: "evenodd"
  })));
};
export default SvgHantLogo;